import * as React from 'react'
import colors from 'theme/colors'

const SvgComponent = ({
  color = colors.borderGrey,
  ...props
}: React.SVGProps<SVGSVGElement>) => {
  const w = 28
  const h = 27
  return (
    <svg
      viewBox={`0 0 ${w} ${h}`}
      width={w}
      height={h}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.5664 13.1211L11.6914 9.87109V16.3711L16.5664 13.1211Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.12891 13.1211C1.12891 16.7712 1.50861 18.9025 1.79033 20.0048C1.86801 20.3039 2.0149 20.5806 2.21916 20.8125C2.42341 21.0444 2.6793 21.2251 2.9662 21.3399C7.0695 22.9078 13.8675 22.871 13.8675 22.871C13.8675 22.871 20.6655 22.9078 24.7688 21.3399C25.0557 21.2251 25.3116 21.0444 25.5159 20.8125C25.7201 20.5806 25.867 20.3039 25.9447 20.0048C26.2264 18.9025 26.6061 16.7712 26.6061 13.1211C26.6061 9.471 26.2264 7.33973 25.9447 6.23735C25.867 5.93824 25.7201 5.66157 25.5159 5.42966C25.3116 5.19775 25.0557 5.01709 24.7688 4.90225C20.6655 3.33442 13.8675 3.37117 13.8675 3.37117C13.8675 3.37117 7.0695 3.33442 2.9662 4.90225C2.6793 5.01709 2.42341 5.19775 2.21916 5.42966C2.0149 5.66157 1.86801 5.93824 1.79033 6.23735C1.50861 7.33973 1.12891 9.471 1.12891 13.1211Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default SvgComponent
